import DOMPurify from 'dompurify'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Comment, PhotoLibrary } from '@mui/icons-material'
import { Box, IconButton, Stack, Typography } from '@mui/material'

import { GRTooltip } from '../../../../../components/GRTooltip/GRTooltip'

type BenchmarkAnswerCellProps = {
  choice?: string
  notes?: string
  screenshotCount: number
  gameName: string
  onViewNote: () => void
  onOpenScreenshots: () => void
}

export const BenchmarkAnswerCell: FC<BenchmarkAnswerCellProps> = ({ choice, notes, screenshotCount, gameName, onViewNote, onOpenScreenshots }) => {
  const { t } = useTranslation()

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant="body2">{choice?.trim() || '---'}</Typography>
      {notes && (
        <GRTooltip
          content={
            <Box>
              <Typography variant="body2" fontWeight="bold">
                {t('internal-analysts:analysis_choices_notes')}
              </Typography>
              <Box dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notes) }} />
            </Box>
          }
        >
          <IconButton size="small" color="success" aria-label={t('internal-analysts:analysis_choices_view_note', { name: gameName })} onClick={onViewNote}>
            <Comment fontSize="small" />
          </IconButton>
        </GRTooltip>
      )}
      {screenshotCount > 0 && (
        <GRTooltip content={t('internal-analysts:analysis_choices_benchmark_screenshots', { count: screenshotCount })}>
          <IconButton
            size="small"
            color="primary"
            aria-label={t('internal-analysts:analysis_choices_view_screenshots', { name: gameName })}
            onClick={onOpenScreenshots}
          >
            <PhotoLibrary fontSize="small" />
          </IconButton>
        </GRTooltip>
      )}
    </Stack>
  )
}
